import React, { useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import IconButton from "@mui/material/IconButton";
import { useMediaQuery } from "@mui/material";
import { requestLinkOrganization } from "../../redux/actions/usersManagementActionCreators";

export default function DeleteModal({
  open,
  handleClose,
  toLink,
  resetForm,
  role,
  handleCloseAddModal,
  firstName,
  lastName,
  managedOrganizations,
  page,
  searchText,
  tabs,
  filter,
  handleOrganization,
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const handleLink = () => {
    dispatch(
      requestLinkOrganization(
        toLink.free_account_admin_uid,
        role,
        toLink.free_account_admin_email,
        firstName,
        lastName,
        managedOrganizations,
        page,
        searchText,
        tabs,
        filter
      )
    );
    resetForm({ values: "" });
    handleOrganization({});
    handleClose();
    handleCloseAddModal();
  };

  const isMobile = useMediaQuery("(max-width:1400px)");
  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xl"
        PaperProps={{
          sx: !isMobile
            ? { width: "55%", padding: "20px " }
            : { width: "90%", height: "80%", margin: "5px 0", padding: "5px " },
        }}
        disableBackdropClick
        disableEnforceFocus
      >
        <Typography
          variant="subtitle3"
          sx={{ display: "flex", alignItems: "center" }}
        >
          <IconButton onClick={handleClose}>
            <KeyboardBackspaceIcon sx={{ width: "70%", color: "black" }} />
          </IconButton>
          {t("back")}
        </Typography>

        <DialogTitle mb={1} align="center">
          <Typography variant="title1" sx={{ fontSize: "38px" }}>
            {t("link_organization")}
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ padding: "15px 10px" }}>
          <DialogContentText mb={2} align="center" id="link-orga">
            {t("link_details")}
          </DialogContentText>
          <DialogContentText mb={2} align="center" id="confirm-link-orga">
            {t("confirm_link")}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ padding: "20px" }}>
          <Grid container spacing={5}>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="deleteButton"
                onClick={handleClose}
                fullWidth
              >
                {t("cancel")}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="button"
                onClick={handleLink}
                fullWidth
              >
                {t("confirm")}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}
